module.exports = __webpack_public_path__ + "media/images/emblems/Rodersdorf-blason-769df3b93d2c348352cd05b4ca131a53.png";